export default __webpack_public_path__ + "static/media/faster.13e1601b.svg";